import AutoPriceConverter from '~/components/AutoPriceConverter';
import { AutoPriceConverterInterface } from '~/payload-types';

type Props = AutoPriceConverterInterface & {};

export const AutoPriceConverterBlock: React.FC<Props> = (props) => {
  return <AutoPriceConverter {...props}></AutoPriceConverter>;
};
